import { Fragment } from "react";
import ProgressBar from "../../charts/progress/ProgressBar";
import { Link } from "react-router-dom";

function BudgetCard({ budget, onClick }) {
  const { name, spent, limit, threshold } = budget;

  return (
    <Fragment>
      <Link className="urt-card budget-card-container" onClick={onClick}>
        <div className="bc-header">
          <p className="bc-title">{name}</p>
        </div>
        <div className="bc-body">
          <div className="bc-progress-chart">
            <ProgressBar spent={spent} total={limit} threshold={threshold} />
          </div>
          <div className="bc-progress-text">
            <span className="progress-text">
              ${spent} of ${limit}
            </span>
            <span className="b-remain">${(limit - spent).toFixed(2)}</span>
          </div>
        </div>
      </Link>
    </Fragment>
  );
}

export default BudgetCard;
